export default __webpack_public_path__ + "static/media/icon_invite.54a0cb83.svg";